var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 62.5 66.79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M9.63 61.47a4.18 4.18 0 0 0 4.23 3.82h34.78a4.22 4.22 0 0 0 4.23-3.82l3.9-40.83h-51zM56.77 7.88h-17V5.73a4.21 4.21 0 0 0-4.22-4.23H27a4.21 4.21 0 0 0-4.23 4.23v2.15H5.73a4.23 4.23 0 0 0 0 8.46h51a4.23 4.23 0 0 0 0-8.46zM22.28 31.04v24m8.75-24v24m8.75-24v24",
    "data-name": "Layer 63"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.5ce28964.svg";
export { ForwardRef as ReactComponent };